// extracted by mini-css-extract-plugin
module.exports = {"acordion":"styles_acordion__pjvA3","message":"styles_message__6NDf_"};